<template>
  <div class="login_p">
    <headd :mobile_title="mobile_title"></headd>
    <div class="login-logo hidden-lg hidden-md">
      <img src="../../../static/login/logo.png" />
    </div>
    <div class="login container">
      <div class="login_sw hidden-sm hidden-xs">
        <div class="swiper-container banner">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in swiper_list"
              :key="item.id"
              :data-index="index"
            >
              <div class="swiper-item swiper">
                <img :src="item.pc_imgUrl" />
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!-- 如果需要滚动条 -->
          <!--    <div class="swiper-scrollbar"></div>-->
        </div>
      </div>
      <div class="login_form">
        <div class="form">
          <div class="form-item">
            <div class="form-item-86">+86</div>
            <div class="form-item-input">
              <input
                type="text"
                v-model="info.username"
                maxlength="11"
                min="1"
                placeholder="请输入手机号"
              />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-input">
              <input
                type="text"
                v-model="info.captcha"
                maxlength="6"
                placeholder="请输入验证码"
                min="1"
              />
            </div>
            <div class="form-item-code" @click="getsmscode" v-show="show">
              获取验证码
            </div>
            <div class="form-item-code" v-show="!show">
              重新发送{{ count }}s
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-input">
              <input
                type="password"
                v-model="info.password"
                placeholder="设置新密码，6-16位"
              />
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-input">
              <input
                type="password"
                v-model="info.comfirm_password"
                placeholder="确认新密码"
              />
            </div>
          </div>

          <div class="button_login" @click="btn_save">重置密码</div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import { getcaptchaResetPass, getresetPassword } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "重置密码",
      activeName: "first",
      captcha: "",
      time_count: 60, //验证码倒计时60s
      count: "",
      show: true,
      info: {
        username: "",
        captcha: "",
        password: "",
        comfirm_password: ""
      },
      swiper_list: [
        {
          id: 1,
          pc_imgUrl: "/static/login/banner/1.png"
        }
      ]
    };
  },
  mounted() {
    new Swiper(".banner", {
      loop: true,
      // 如果需要分页器
      pagination: ".swiper-pagination"
      // 如果需要前进后退按钮
      //nextButton: ".swiper-button-next",
      //prevButton: ".swiper-button-prev"
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      // autoplay: {
      //   delay: 1000,//时间 毫秒
      //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
      // },
    });
  },
  components: {
    headd,
    foot
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async btn_save() {
      var _self = this;
      var data = _self.info;
      console.log(data.username);
      var phone_reg = /^1[3456789]\d{9}$/;
      if (data.username == "") {
        this.$toast("手机号不能为空");

        return false;
      } else {
        if (!phone_reg.test(data.username)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.captcha == "") {
        this.$toast("验证码不能为空");
        return false;
      }
      if (data.password == "") {
        this.$toast("密码不能为空");

        return false;
      }
      if (data.password != data.comfirm_password) {
        this.$toast("密码不一致");

        return false;
      }
      const res = await getresetPassword(data);

      if (res.status == 1) {
        //uni.setStorageSync("sessionToken", res.data.data.sessionToken);
        this.$toast({
          message: "密码重置成功",
          type: "success"
        });

        setTimeout(function() {
          _self.$router.push({
            path: "login"
          });
        }, 1000);
      } else {
        //this.$message(res.msg);
      }
    },
    async getsmscode() {
      //console.log(this.info)
      var mobile = this.info.username;
      var phone_reg = /^1[3456789]\d{9}$/;
      //console.log(mobile)
      if (mobile) {
        //console.log(phone_reg.test(mobile))
        if (phone_reg.test(mobile)) {
          //符合正则

          if (!this.timer) {
            this.count = this.time_count;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= this.time_count) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
            var parm = {
              mobile: mobile
            };
            const res = await getcaptchaResetPass(parm);
            if (res.status == 1) {
              this.$toast("验证码已发送");
            }
          }
        } else {
          this.$toast("手机号码格式错误");
        }
      } else {
        this.$toast("手机号码不能为空");
      }
    }
  }
};
</script>
<style lang="less" scoped="">
.login_p {
  background: #ccc;
  height: auto;
  overflow: hidden;
  @media (max-width: 991px) {
    background: #fff;
  }
  .login-logo {
    margin-top: 1.32rem;
    margin-bottom: 0.6rem;
    width: 2.1rem;
    height: 1.77rem;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
.login {
  display: flex;
  margin: 0.3rem auto;
  border: 0.01rem solid #ccc;
  padding: 0.3rem 1.1rem;
  border-radius: 0.2rem;
  background: #fff;
  @media (max-width: 991px) {
    border-radius: 0;
    border: 0;
  }
  .login_sw {
    width: 3.76rem;
    margin-right: 1.6rem;
    img {
      width: 100%;
    }
  }
  .login_form {
    width: 4.58rem;
    flex-direction: column;
    align-items: center;
    display: flex;
    @media (max-width: 991px) {
      width: 6.5rem;
      margin: auto;
    }
    .login-form {
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .login-nav {
        margin-bottom: 0.49rem;
      }

      .form {
        flex-direction: column;
        position: relative;
      }

      .register {
        font-size: 0.26rem;
        text-decoration: underline;
        margin-bottom: 0.2rem;
      }
      .tip {
        font-size: 0.26rem;
      }
    }
  }
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset; /**通过边框阴影遮挡住背景*/
  -webkit-text-fill-color: #333;
}

.form-item {
  width: 100%;
  padding: 0.15rem 0;
  font-size: 0.24rem;
  height: 0.7rem;
  border-bottom: 0.01rem solid #c4c4cc;
  align-items: center;
  margin-bottom: 0.2rem;
  justify-content: flex-start;
  display: flex;
  @media (max-width: 991px) {
    padding: 0.25rem 0;
    height: auto;
  }
  .form-item-86 {
    width: 0.5rem;
    margin-right: 0.5rem;
    font-size: 0.2rem;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }

  .form-item-code {
    width: 1.5rem;
    color: #1395ff;
    font-size: 0.2rem;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      width: 3rem;
      text-align: right;
    }
  }

  .form-item-input {
    width: 100%;
    input {
      width: 100%;
      border: none;
      background: transparent;
      font-size: 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }
}
.button_login {
  width: 100%;
  height: 0.68rem;
  background: #1395ff;
  border-radius: 0.34rem;
  font-size: 0.24rem;
  line-height: 0.68rem;
  color: #fff;
  cursor: pointer;
  @media (max-width: 991px) {
    margin: 0.3rem auto;
    width: 5.9rem;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    -webkit-border-radius: 0.4rem;
    border-radius: 0.4rem;
    font-size: 0.36rem;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
  }
}
/deep/.el-tabs__item {
  font-size: 0.2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/view/setpassword/setpassword.vue